module.exports = __webpack_public_path__ + "img/ynbf.58805104.jpg";